import React, { createContext, useContext, useState } from "react";
import { PrayerSource, getPrayerSource } from "../components/PrayerSourceSelector";

interface PrayerSourceContextType {
    prayerSource: PrayerSource;
    setPrayerSource: (source: PrayerSource) => void;
}

const PrayerSourceContext = createContext<PrayerSourceContextType>({
    prayerSource: "islamiska",
    setPrayerSource: () => { },
});

export const PrayerSourceProvider = ({ children }: { children: React.ReactNode }) => {
    const [prayerSource, setPrayerSourceState] = useState<PrayerSource>(getPrayerSource());

    const setPrayerSource = (source: PrayerSource) => {
        localStorage.setItem("prayerSource", source);
        setPrayerSourceState(source);
    };

    return (
        <PrayerSourceContext.Provider value={{ prayerSource, setPrayerSource }}>
            {children}
        </PrayerSourceContext.Provider>
    );
};

export const usePrayerSource = () => useContext(PrayerSourceContext);
